export { default } from './StaticPageTitle';
